// extracted by mini-css-extract-plugin
module.exports = {"root":"Tag_root__Hx4AV","wrapper":"Tag_wrapper__BoRh4","secondary":"Tag_secondary__FT1x_"};